export const chartLoadedEvent = [
    '$window',
    '$timeout',
    '$rootScope',
    function ($window, $timeout, $rootScope) {
        const debounceMap = new Map();

        // optional debounce timeout
        return function (timeout, chartId = 'unknown') {
            if (debounceMap.has(chartId)) {
                $timeout.cancel(debounceMap.get(chartId));
                debounceMap.delete(chartId);
            }

            // for outside controller like taking screenshot
            // use timeout so that the loading icon disappear
            const timeoutId = $timeout(function () {
                if ($rootScope.captureMode) {
                    if ($window.chartReady && typeof $window.chartReady === 'function') {
                        $window.chartReady(chartId);
                    }
                } else {
                    if ($window.chartLoaded && typeof $window.chartLoaded === 'function') {
                        $window.chartLoaded(chartId);
                    }
                }
                debounceMap.delete(chartId);
            }, timeout);
            debounceMap.set(chartId, timeoutId);
        };
    },
];
